"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return LogLevel;
    }
});
const LogLevel = {
    error: 10,
    warn: 20,
    info: 30,
    verbose: 40,
    silly: 50
};
